import { CompletedEvaluationModel, EvalIds, StripeProductModel } from "graphql/generated";

export enum SectionType {
  evaluationQuestions = "evaluation_questions",
  DOBInput = "DOB_input",
  medsSelection = "meds_selection",
  productSelection = "product_selection",
  treatmentSummary = "treatment_summary",
  dosageSelection = "dosage_selection",
  freqSelection = "freq_selection"
}

// the step is in order if need all step show
export type SectionStateType =
  | "evaluation_questions"
  | "DOB_input"
  | "medication_steps"
  | "meds_selection"
  | "product_selection"
  | "treatment_summary"
  | "dosage_selection"
  | "freq_selection";

export type EvalFlowPriceSelectionVariant = "dosage" | "frequency";

export type ProductGroupsProps = {
  isSkippedEval: boolean;
  conditionId: EvalIds;
  completedEvaluations: CompletedEvaluationModel[];
  currentGroup: any;
  isLastProductGroup: boolean;
  setCurrentIndex: (newIndex: number) => void;
  currentIndex: number;
  currentProductGroups: any[];
  evaluationSysId: string;
  currentEvaluation: CompletedEvaluationModel;
};

export type TreatmentSummaryDataProps = {
  curProduct: StripeProductModel;
  curPriceId?: string;
  conditionId: EvalIds;
  isSkippedEval: boolean;
  isRxChangeOrSkipMed?: boolean;
};
